/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Tableheaders_Pos1Inputs */

const id_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const ms_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const da_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const de_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const en_us2_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const es_es2_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const es_mx2_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const fil_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const fr_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const it_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const hu_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poz`)
};

const nl_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const no_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const pl_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poz`)
};

const pt_br2_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos.`)
};

const pt_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const ro_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poz`)
};

const fi_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sij`)
};

const sv_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pos`)
};

const vi_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí`)
};

const tr_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıra`)
};

const cs_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poz`)
};

const bg_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поз`)
};

const ru_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`№`)
};

const uk_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поз`)
};

const ar_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`م`)
};

const hi_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्था`)
};

const th_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตำแหน่ง`)
};

const ja_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位`)
};

const zh_cn2_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const zh_hant1_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const ko_home_tableheaders_pos1 = /** @type {(inputs: Home_Tableheaders_Pos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순위`)
};

/**
* | output |
* | --- |
* | "Pos" |
*
* @param {Home_Tableheaders_Pos1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_tableheaders_pos1 = /** @type {((inputs?: Home_Tableheaders_Pos1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Tableheaders_Pos1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_tableheaders_pos1(inputs)
	if (locale === "ms") return ms_home_tableheaders_pos1(inputs)
	if (locale === "da") return da_home_tableheaders_pos1(inputs)
	if (locale === "de") return de_home_tableheaders_pos1(inputs)
	if (locale === "en-US") return en_us2_home_tableheaders_pos1(inputs)
	if (locale === "es-ES") return es_es2_home_tableheaders_pos1(inputs)
	if (locale === "es-MX") return es_mx2_home_tableheaders_pos1(inputs)
	if (locale === "fil") return fil_home_tableheaders_pos1(inputs)
	if (locale === "fr") return fr_home_tableheaders_pos1(inputs)
	if (locale === "it") return it_home_tableheaders_pos1(inputs)
	if (locale === "hu") return hu_home_tableheaders_pos1(inputs)
	if (locale === "nl") return nl_home_tableheaders_pos1(inputs)
	if (locale === "no") return no_home_tableheaders_pos1(inputs)
	if (locale === "pl") return pl_home_tableheaders_pos1(inputs)
	if (locale === "pt-BR") return pt_br2_home_tableheaders_pos1(inputs)
	if (locale === "pt") return pt_home_tableheaders_pos1(inputs)
	if (locale === "ro") return ro_home_tableheaders_pos1(inputs)
	if (locale === "fi") return fi_home_tableheaders_pos1(inputs)
	if (locale === "sv") return sv_home_tableheaders_pos1(inputs)
	if (locale === "vi") return vi_home_tableheaders_pos1(inputs)
	if (locale === "tr") return tr_home_tableheaders_pos1(inputs)
	if (locale === "cs") return cs_home_tableheaders_pos1(inputs)
	if (locale === "bg") return bg_home_tableheaders_pos1(inputs)
	if (locale === "ru") return ru_home_tableheaders_pos1(inputs)
	if (locale === "uk") return uk_home_tableheaders_pos1(inputs)
	if (locale === "ar") return ar_home_tableheaders_pos1(inputs)
	if (locale === "hi") return hi_home_tableheaders_pos1(inputs)
	if (locale === "th") return th_home_tableheaders_pos1(inputs)
	if (locale === "ja") return ja_home_tableheaders_pos1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_tableheaders_pos1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_tableheaders_pos1(inputs)
	return ko_home_tableheaders_pos1(inputs)
});
export { home_tableheaders_pos1 as "home.tableHeaders.pos" }